<template>
	<b-card>
		<template #header>
			<span style="font-size: 20px; font-weight: bold">Накладные</span>
			<b-input-group class="float-right shadow" style="width: 250px">
				<template #prepend>
					<b-button class="fa fa-search"/>
				</template>
				<b-form-input v-model="search" placeholder="Поиск"/>
				<template #append>
					<b-button @click="createDoc()" variant="outline-primary" class="fa fa-plus"/>
				</template>
			</b-input-group>
		</template>
		<b-overlay :show="loading" rounded="sm">
			<table class="table table-bordered table-hover">
				<thead>
				<tr>
					<th class="text-center">{{ '№' }}</th>
					<th class="text-center">{{ 'Дата' }}</th>
					<th class="text-center">{{ 'Документ №' }}</th>
					<th class="text-center">{{ 'Создатель' }}</th>
					<th class="text-center">{{ 'Дата создания' }}</th>
					<th class="text-center">{{ 'Обнавлён' }}</th>
					<th class="text-center">{{ 'Дата обновления' }}</th>
					<th class="text-center">{{ 'Сотрудники' }}</th>
					<th class="text-center">{{ 'Статус' }}</th>
					<!--<th class="text-center">{{ 'Готов к продаже' }}</th>-->
					<th class="text-center">{{ $t('goods.actions') }}</th>
				</tr>
				</thead>
				<tbody v-if="docs.length > 0">
				<tr v-for="(item, index) in docs" :key="`group-${index}`">
					<td class="text-center">{{ paginate(index, payload.page, payload.limit) }}</td>
					<td class="text-center">{{ item.regDate }}</td>
					<td class="text-center">{{ item.regNumber }}</td>
					<td class="text-center">{{ item.docCreatedBy }}</td>
					<td class="text-center">{{ item.docCreatedDate }}</td>
					<td class="text-center">{{ item.docLastModifiedBy }}</td>
					<td class="text-center">{{ item.docChangedDate }}</td>
					<td class="text-center">
						<div v-for="(emp,index) in item.employeeDtos" :key="`employee-${index}`">
							<b-badge variant="dark" style="font-size: 10px">{{ emp.lastName + ' ' + emp.firstName + ' ' + emp.middleName }}</b-badge><br>
						</div>
					</td>
					<td class="text-center">{{ item.documentStatus }}</td>
					<!--<td class="text-center">-->
					<!--<b-badge :variant="item.beforeReady ? 'success' : 'danger'">{{ item.beforeReady ? 'Да' : 'Нет' }}</b-badge>-->
					<!--</td>-->
					<td class="text-center" style="width: 13%">
						<i v-if="item.documentStatus !== 'SUSPENDED'" @click="copyDoc(item)" class="fa fa-copy text-dark pointer-event"/>
						<i v-if="item.documentStatus === 'SUSPENDED'" @click="editForm(item)" class="fa fa-pencil text-primary pointer-event ml-3"/>
						<i v-if="item.documentStatus === 'SUSPENDED'" @click="deleteForm(item)" class="fa fa-trash text-danger pointer-event ml-3"/>
						<i v-if="item.documentStatus === 'PENDING'" @click="toPos(item)" class="fa fa-desktop text-success pointer-event ml-3"/>
						<i v-if="item.documentStatus !== 'SUSPENDED'" @click="viewDoc(item)" class="fa fa-eye text-dark pointer-event ml-3"/>
						<i v-if="item.documentStatus === 'PENDING'" @click="saleDoc(item)" class="fa fa-check text-success pointer-event ml-3"/>
						<i v-if="item.documentStatus === 'READY'" @click="$router.push(`/warehouse-management/skyShopReport/view/${item.id}`)" class="fa fa-list text-dark pointer-event ml-3"/>
					</td>
				</tr>
				</tbody>
				<tbody v-else>
				<tr>
					<td class="text-center" colspan="10">{{ $t('empty') }}</td>
				</tr>
				</tbody>
			</table>
			<nav class="text-center mt-2">
				<b-pagination-new background :total="total" layout="prev, pager, next" :page-size="payload.limit" :current-page.sync="payload.page"/>
			</nav>
		</b-overlay>

		<!--      Create Or Edit Doc      -->
		<b-modal v-model="createOrEditModal" size="xl" :title="create ? `Создать / ${docForm.regNumber}` : `Редактировать / ${docForm.regNumber}`" hide-footer :busy="loading" no-close-on-backdrop no-close-on-esc>
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col cols="4">
						<b-input-group prepend="Документ №">
							<b-form-input v-model="docForm.regNumber" disabled/>
						</b-input-group>
						<b-input-group prepend="Датa" class="mt-3">
							<date-picker v-model="docForm.regDate" style="left: -14px" name="regDate" lang="ru" :placeholder="$t('incomes.create.reg-date')" valueType="format" format="DD-MM-YYYY"/>
						</b-input-group>
						<multiselect v-model="docForm.departmentId" :options="departments" track-by="id" :show-labels="false" :allow-empty="true" label="name" :placeholder="$t('incomeFilter.department')" class="multiselect-pricing mt-3" @select="changeDep"/>
						<div v-if="brigadeEmployees.length>0">
							<div v-for="(brigade,index) in brigadeEmployees" :key="`brigade-employee-${index}`" class="mt-3">
								<multiselect v-model="brigade.brigadeEmployees" @select="brigadeEmployees.push({}); brigadeEmployees.splice(brigadeEmployees.length-1, 1)" @remove="brigadeEmployees.push({}); brigadeEmployees.splice(brigadeEmployees.length-1, 1)" track-by="id" :searchable="true" :show-labels="false" :options="employees" :multiple="true" :close-on-select="true" :internal-search="false" :custom-label="sellerCustomLabel" :placeholder="`${brigade.name} -- Выберите бортпроводника`" @search-change="getEmployees($event)">
									<template slot="option" slot-scope="option">
										{{ sellerCustomLabel(option.option) }}
									</template>
								</multiselect>
								<b-badge v-if="(brigadeEmployees.length !== brigades.length) && (brigadeEmployees.length===(index+1))" @click="addBrigade(index)" class="float-right" variant="primary"><i class="fa fa-plus"/></b-badge>
								<b-badge v-if="(brigadeEmployees.length===(index+1)) && (index!==0)" @click="removeBrigade(index)" variant="danger" class="float-right"><i class="fa fa-minus"/></b-badge>
							</div>
						</div>
						<div v-else class="mt-3">
							<span class="text-danger">Сначала создайте бригаду!</span>
						</div>
					</b-col>
					<b-col>
						<multiselect v-model="item" :options="items" :searchable="true" :show-labels="false" :internal-search="false" :loading="loading" :close-on-select="true" label="name" :disabled="!docForm.departmentId" track-by="id" @search-change="loadItems($event)" :placeholder="$t('incomes.create.product')" @select="addItem">
							<template slot="singleLabel" slot-scope="props">
								<span>
									{{ props.option.artikul }} / {{props.option.barcode }} / {{ props.option.name }} / {{ props.option.termOfItem }}
								</span>
							</template>
							<template slot="option" slot-scope="option">
								<span>
									{{option.option.barcode }} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }} / {{ option.option.regNumber }}<strong> - {{ option.option.regDate }}</strong>
								</span>
							</template>
						</multiselect>
						<table class="table table-bordered table-hover" style="width: 100%">
							<thead>
							<tr>
								<th class="text-center">{{ '№' }}</th>
								<th class="text-center">{{ 'Спец-код' }}</th>
								<th class="text-center">{{ 'Продукт' }}</th>
								<th class="text-center">{{ 'Количество' }}</th>
								<th class="text-center">{{ 'Остатка' }}</th>
								<th class="text-center">{{ 'Цена (штук)' }}</th>
								<th class="text-center">{{ 'Сумма (Цена)' }}</th>
								<th class="text-center">{{ $t('goods.actions') }}</th>
							</tr>
							</thead>
							<tbody v-if="docForm.whItems && docForm.whItems.length > 0">
							<tr v-for="(item, index) in docForm.whItems" :key="`wh-items-${index}`" :class="item.count>item.inventoryNum?'bg-danger':''">
								<td class="text-center">{{ index+1 }}</td>
								<td class="text-center">{{ item.barcode }}</td>
								<td class="text-center">{{ item.itemName }}</td>
								<td class="text-center">
									<b-input v-model="item.count" type="number" :max="item.inventoryNum" @input="$forceUpdate()"/>
								</td>
								<td class="text-center">{{ item.inventoryNum }}</td>
								<td class="text-center">{{ item.price }}</td>
								<td class="text-center">{{ item.count*item.price }}</td>
								<td class="text-center" style="width: 10%">
									<div :class="item.count>item.inventoryNum?'text-white':'text-danger'">
										<i @click="localDeleteItem(index)" class="fa fa-trash pointer-event"/>
									</div>
								</td>
							</tr>
							</tbody>
							<tbody v-else>
							<tr>
								<td class="text-center" colspan="10">{{ $t('empty') }}</td>
							</tr>
							</tbody>
						</table>
					</b-col>
				</b-row>
				<hr>
				<b-row>
					<b-col align="right">
						<b-button @click="cancel" variant="outline-danger" class="mr-2">Отменить</b-button>
						<b-button @click="save('SUSPENDED')" variant="warning" class="mr-2">Сохранить</b-button>
						<b-button @click="save('PENDING')" variant="success">Сохранить и закончить</b-button>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>

		<!--      Sale View Doc      -->
		<b-modal v-model="saleViewModal" size="xl" :title="`Продажа продуктов`" hide-footer :busy="loading" no-close-on-backdrop no-close-on-esc>
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col>
						<table style="width: 100%">
							<tr>
								<td>Номер:</td>
								<td><b>{{docForm.regNumber}}</b></td>
								<td>Откуда:</td>
								<td><b>{{docForm.fromDepartmentName}}</b></td>
							</tr>
							<tr>
								<td>Дата:</td>
								<td><b>{{docForm.regDate}}</b></td>
								<td>Кому:</td>
								<td>
									<div v-for="emp in docForm.employeeDtos" :key="`emp-${emp.id}`">
										<b>{{ emp.lastName + ' ' + emp.firstName + ' ' + emp.middleName }}</b><br>
									</div>
								</td>
							</tr>
						</table>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<b-table-simple striped hover responsive sticky-header>
							<b-thead>
								<b-tr>
									<b-th class="text-center">{{ '№' }}</b-th>
									<b-th class="text-center">{{ 'Спец-код' }}</b-th>
									<b-th class="text-center">{{ 'Продукт' }}</b-th>
									<b-th class="text-center">{{ 'Продать' }}</b-th>
									<b-th class="text-center">{{ 'Количество' }}</b-th>
									<b-th class="text-center">{{ 'Цена (штук)' }}</b-th>
									<b-th class="text-center">{{ 'Сумма (Цена)' }}</b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<b-tr v-for="(item,index) in docForm.whItems" :key="`items-${index}`" :class="item.skyQty>item.count?'bg-danger':''">
									<b-td class="text-center">{{index+1}}</b-td>
									<b-td class="text-center">{{item.barcode}}</b-td>
									<b-td class="text-center">{{item.itemName}}</b-td>
									<b-td class="text-center">
										<b-form-input v-model="item.skyQty" type="number" :max="item.count" @input="$forceUpdate()"/>
									</b-td>
									<b-td class="text-center">{{item.count}}</b-td>
									<b-td class="text-center">{{item.priceUzs}}</b-td>
									<b-td class="text-center">{{(item.skyQty?item.skyQty:0)*item.priceUzs}}</b-td>
								</b-tr>
								<b-tr>
									<b-td colspan="6" class="text-right"><b>Итого</b></b-td>
									<b-td class="text-center">{{ sumPriceCount }}</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</b-col>
				</b-row>
				<b-row>
					<b-col align="right">
						<b-button @click="createDraftSale" :disabled="!sumPriceCount" variant="success">Сохранить</b-button>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>
	</b-card>
</template>

<script>
import {Pagination} from 'element-ui';
import {BOverlay} from 'bootstrapVue2';
import SkyShopService from './skyshop.service';
import Multiselect from 'vue-multiselect'
import UsersService from "../../services/users.sevice";
import {BTableSimple, BThead, BTr, BTh, BTbody, BTd} from 'bootstrap-vue';
import FboxService from "../../services/fbox.service";

export default {
	components: {BOverlay, "b-pagination-new": Pagination, Multiselect, BTableSimple, BThead, BTr, BTh, BTbody, BTd},
	data() {
		return {
			search: '',
			loading: false,
			payload: {
				page: 1,
				limit: 20
			},
			total: 0,
			items: [],
			docs: [],
			item: null,
			createOrEditModal: false,
			create: true,
			docForm: {},
			employees: [],
			disabled: false,
			saleViewModal: false,
			departments: [],
			brigadeEmployees: [],
			brigades: []
		}
	},
	watch: {
		'search': {
			handler(s) {
				this.getDocs();
			}
		},
		'payload.page': {
			handler(p) {
				this.getDocs();
			}
		}
	},
	computed: {
		sumPriceCount() {
			if (this.docForm.whItems && this.docForm.whItems.length>0) {
				let sum = 0
				this.docForm.whItems.forEach(t => {
					if (t.skyQty)
						sum+=(t.skyQty*t.priceUzs)
				})
				return sum
			} else {
				return 0
			}
		}
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		sellerCustomLabel(seller) {
			return (seller.firstName + " " + seller.lastName);
		},
		getEmployees(search) {
			this.loading = true
			SkyShopService.getEmployees(search).then(res => {
				this.employees = res.data
				this.loading = false
			}).catch(er => {
				this.loading = false
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async getDepartments() {
			const getResponse = await UsersService.getPermittedDepartments();
			this.departments = getResponse.data.permittedDepartments
		},
		changeDep($event) {
			this.loadItems('', $event.id);
		},
		loadItems(search, depId) {
			this.loading = true
			if (depId || this.docForm.departmentId) {
				SkyShopService.getWhItems(search, depId ? depId : this.docForm.departmentId.id).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.$vs.notify({
					title: 'Сначала выбери подразделение !',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		addItem($event) {
			let tmp = {
				barcode: $event.barcode,
				count: $event.count?$event.count:0,
				currencyId: null,
				documentId: this.docForm.id,
				excelFile: "",
				fromDepartmentId: this.docForm.departmentId.id,
				id: $event.id ? $event.id : null,
				incomeDocId: "",
				incomingPriceUsd: null,
				incomingPriceUzs: 0,
				inventoryNum: $event.count1,
				itemId: $event.id ? $event.id : null,
				itemName: $event.name,
				multiBarcodes: $event.multiBarcodes,
				price: $event.price,
				priceUsd: null,
				priceUzs: $event.price,
				priceWholesale: 0,
				providerId: null,
				providerName: null,
				realBalance: $event.count1,
				regNumber: this.docForm.regNumber,
				sectorId: null,
				toDepartmentId: null,
				unitName: $event.unitName,
				wrapped: $event.wrapped
			}
			if (this.docForm.whItems && this.docForm.whItems.length > 0) {
				let ind = null,
					has = false;
				this.docForm.whItems.forEach((item,index) => {
					if (item.itemId === tmp.itemId) {
						ind = index
						has = true
					}
				})
				if (has) {
					tmp.count = this.docForm.whItems[ind].count
					this.docForm.whItems.splice(ind, 1)
					this.docForm.whItems.unshift(tmp)
				} else {
					this.docForm.whItems.unshift(tmp)
				}
			} else {
				this.docForm.whItems = []
				this.docForm.whItems.unshift(tmp)
			}
		},
		localDeleteItem(index) {
			this.item = null
			this.docForm.whItems.splice(index, 1)
			this.$forceUpdate();
		},
		getDocs() {
			this.loading = true
			this.payload.attributes = [{field: 'regNumber', value: this.search, option: 'CONTAINS'}]
			SkyShopService.getDocs(this.payload).then(res => {
				this.docs = res.data.items
				this.total = res.data.total
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		addBrigade(index) {
			this.brigades[index+1].brigadeEmployees = []
			this.brigadeEmployees.push(this.brigades[index+1])
		},
		removeBrigade(index) {
			this.brigadeEmployees.splice(index, 1)
		},
		createDoc() {
			this.create = true
			let tmp = {
				action : 'SKY_CHIQIM',
				documentType : 'NAKLADNOY'
			}
			SkyShopService.createDraftDoc(tmp).then(res => {
				this.docForm = res.data
				this.getEmployees('');
				this.brigadeEmployees = []
				this.brigades[0].brigadeEmployees = []
				this.brigadeEmployees.unshift(this.brigades[0])
				this.createOrEditModal = true
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async copyDoc(doc) {
			this.loading = true
			this.create = true
			let tmp = {
				action : 'SKY_CHIQIM',
				documentType : 'NAKLADNOY'
			}
			await SkyShopService.createDraftDoc(tmp).then(res => {
				this.docForm = res.data
				this.getEmployees('');
				this.brigadeEmployees = []
				this.brigades[0].brigadeEmployees = []
				this.brigadeEmployees.unshift(this.brigades[0])
				this.createOrEditModal = true
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await SkyShopService.getDocByIdForEdit(doc.id).then(res => {
				this.departments.forEach(d => {
					if (d.id === res.data.fromDepartmentId) {
						this.docForm.departmentId = d
					}
				})
				this.docForm.whItems = []
				res.data.whItems.forEach(item => {
					let tmp = {
						barcode: item.barcode,
						count: item.count?item.count:0,
						currencyId: null,
						documentId: this.docForm.id,
						excelFile: "",
						fromDepartmentId: this.docForm.fromDepartmentId,
						id: item.id ? item.id : null,
						incomeDocId: "",
						incomingPriceUsd: null,
						incomingPriceUzs: 0,
						inventoryNum: item.realBalance,
						itemId: item.itemId ? item.itemId : null,
						itemName: item.itemName,
						multiBarcodes: item.multiBarcodes,
						price: item.priceUzs,
						priceUsd: null,
						priceUzs: item.priceUzs,
						priceWholesale: 0,
						providerId: null,
						providerName: null,
						realBalance: item.realBalance,
						regNumber: this.docForm.regNumber,
						sectorId: null,
						toDepartmentId: null,
						unitName: item.unitName,
						wrapped: item.wrapped
					}
					this.docForm.whItems.push(tmp)
				})
				this.loadItems('');
				this.loading = false
				this.createOrEditModal = true
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		editForm(doc) {
			this.loading = true
			SkyShopService.getDocByIdForEdit(doc.id).then(res => {
				this.docForm = Object.assign({}, res.data)
				this.departments.forEach(d => {
					if (d.id === res.data.fromDepartmentId) {
						this.docForm.departmentId = d
					}
				})
				this.brigadeEmployees = []
				res.data.brigadeDtos.forEach(b => {
					b.brigadeEmployees = b.employeeDtos
				})
				this.brigadeEmployees = res.data.brigadeDtos
				this.docForm.whItems = []
				res.data.whItems.forEach(item => {
					let tmp = {
						barcode: item.barcode,
						count: item.count?item.count:0,
						currencyId: null,
						documentId: this.docForm.id,
						excelFile: "",
						fromDepartmentId: this.docForm.fromDepartmentId,
						id: item.id ? item.id : null,
						incomeDocId: "",
						incomingPriceUsd: null,
						incomingPriceUzs: 0,
						inventoryNum: item.realBalance,
						itemId: item.itemId ? item.itemId : null,
						itemName: item.itemName,
						multiBarcodes: item.multiBarcodes,
						price: item.priceUzs,
						priceUsd: null,
						priceUzs: item.priceUzs,
						priceWholesale: 0,
						providerId: null,
						providerName: null,
						realBalance: item.realBalance,
						regNumber: this.docForm.regNumber,
						sectorId: null,
						toDepartmentId: null,
						unitName: item.unitName,
						wrapped: item.wrapped
					}
					this.docForm.whItems.push(tmp)
				})
				this.loadItems('');
				this.create = false
				this.loading = false
				this.createOrEditModal = true
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		deleteForm(doc) {
			this.$bvModal.msgBoxConfirm('Вы уверены, что хотите удалить?', {
				title: 'Подтвердите',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Да',
				cancelTitle: 'Нет',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				this.loading = true
				SkyShopService.deleteDoc(doc.id).then(res => {
					this.getDocs();
					this.loading = false
					this.$vs.notify({
						title: 'Успешно удалено!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}).catch(err => {
				console.log(err)
			})
		},
		viewDoc(doc) {
			this.$router.push(`/warehouse-management/skyShop/view/${doc.id}`);
		},
		async toPos(doc) {
			this.loading = true
			await FboxService.getFiscalIpData().then(res => {
				this.loading = false
					if (res.data.departmentId && res.data.id) {
						localStorage.setItem('cash_id', res.data.id)
						localStorage.setItem('dep_id', res.data.departmentId)
						localStorage.setItem('dep_name', res.data.departmentName)
						localStorage.setItem('ip_address', res.data.ipAddress)
						localStorage.setItem('cash_number', res.data.name)
						localStorage.setItem('is_bar', res.data.isBar)
						localStorage.setItem('is_sky_shop', res.data.isSkyShop)
						this.$router.push(`/point-of-sale/pos-v2/${res.data.departmentId}/${res.data.id}?docId=${doc.id}`)
					} else {
						this.$vs.notify({
							title: '',
							icon: 'close',
							color: 'danger',
							position: 'top-right'
						})
					}
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					icon: 'close',
					color: 'danger',
					position: 'top-right'
				})
			})
		},
		async saleDoc(doc) {
			this.loading = true
			await SkyShopService.saveReadyDoc(doc.id).then(res => {
				this.loading = false
				this.getDocs();
				this.$vs.notify({
					title: 'Success',
					icon: 'close',
					color: 'success',
					position: 'top-right'
				})
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					icon: 'close',
					color: 'danger',
					position: 'top-right'
				})
			})
		},
		cancel() {
			this.docForm = {}
			this.item = null
			this.loading = false
			this.disabled = false
			this.createOrEditModal = false
			this.saleViewModal = false
			this.getDocs();
		},
		save(status) {
			if (this.docForm.departmentId && this.docForm.regDate && this.brigadeEmployees.length>0 && this.brigadeEmployees[0].brigadeEmployees.length>0) {
				let employees = []
				this.brigadeEmployees.forEach(tmp => {
					tmp.brigadeEmployees.forEach(emp => {
						let data = Object.assign({}, emp)
						data.brigadeId = tmp.id
						employees.push(data)
					})
				})
				let data = {
					action: this.docForm.action,
					comment: null,
					contragentId: null,
					contragentName: "",
					currencyId: null,
					customsRegDate: "",
					documentStatus: status,
					documentType: this.docForm.documentType,
					fromCurrencyRate: null,
					fromDepartmentId: this.docForm.departmentId.id,
					fromDepartmentName: null,
					fromEmployeeId: null,
					fromEmployeeName: null,
					employeeDtos: employees,
					id: this.docForm.id,
					initiatorId: null,
					reason: "",
					regDate: this.docForm.regDate,
					regNumber: this.docForm.regNumber,
					responsible1Id: null,
					responsible1Name: "",
					responsible2Id: null,
					responsible2Name: "",
					toCurrencyRate: null,
					toDepartmentId: null,
					toDepartmentName: null,
					toEmployeeId: null,
					toEmployeeName: "",
					whItems: this.docForm.whItems
				}
				let can = true
				this.docForm.whItems.forEach(item => {
					if (item.count > item.inventoryNum)
						can = false
				})
				if (can) {
					this.loading = true
					SkyShopService.saveDoc(data).then(res => {
						this.cancel();
						this.loading = false
						this.$vs.notify({
							title: 'Успешно сохранено!',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					this.$vs.notify({
						title: 'Количество товара не должно быть больше чем остатка !',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}
			} else {
				this.$vs.notify({
					title: 'Заполните все обязательные поля!',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		createDraftSale() {
			let can = true
			this.docForm.whItems.forEach(item => {
				if (item.skyQty) {
					if (item.skyQty > item.count) {
						can = false
					} else {
						item.skyQty=parseFloat(item.skyQty)
					}
				}
			})
			if (can) {
				this.loading = true
				this.docForm.beforeReady = true
				SkyShopService.saveDoc(this.docForm).then(res => {
					this.cancel();
					this.loading = false
					this.$vs.notify({
						title: 'Успешно сохранено!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.$vs.notify({
					title: 'Количество продажных товар не должно быть больше чем количество !',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	created() {
		this.getDepartments();
		this.getDocs();
		SkyShopService.getBrigade().then(res => {
			this.brigades = res.data
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
	}
}
</script>

<style scoped>
.pointer-event:hover {
	cursor: pointer;
}
</style>
